export default __webpack_public_path__ + "static/media/imgBio.c394a56a.webp";